import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingCounter = 0;
  private loadingKeyCounter = new Set<string>();
  private loadingSubject = new BehaviorSubject<boolean>(false);

  loading$ = this.loadingSubject.asObservable();

  loadingOn(key: string | null = null) {
    if (key) {
      this.loadingKeyCounter.add(key);
    } else {
      this.loadingCounter++;
    }

    this.loadingSubject.next(true);
  }

  loadingOff(key: string | null = null) {
    if (key) {
      this.loadingKeyCounter.delete(key);
    } else {
      this.loadingCounter--;
    }

    if (this.loadingCounter <= 0 && this.loadingKeyCounter.size == 0) {
      this.loadingCounter = 0;
      this.loadingSubject.next(false);
    }
  }
}
